enum staleTimeSettings {
  NONE = 0,
  LOW = 30 * 1000, // 30 seconds
  MEDIUM = 5 * 60 * 1000, // 5 minutes
  HIGH = 60 * 60 * 1000, // 1 hour
  INFINITE = Infinity,
}

export default staleTimeSettings;
